<div>
  <ds-radio-group
    data-cy="choosePaymentRadioButtons"
    class="radio-group-container"
    [control]="'choosePaymentAmount'"
    [unselectAll]="unselectAll"
    [selectedAnswer]="'0'"
    [parentFormGroup]="formGroup"
    [options]="choosePaymentAmountOptions"
    (optionSelected)="radioGroupChangeEvent($event)"
  >
  </ds-radio-group>
  <p>Enter a different amount</p>
  <ds-form-control-container [control]="formGroup.controls['differentPaymentAmount']">
    <input
      type="text"
      maxlength="8"
      id="differentPaymentAmount"
      [value]="formGroup?.controls['differentPaymentAmount']?.value"
      class="fill"
      formControlName="'differentPaymentAmount'"
      (click)="textBoxChangeEvent($event)"
      (change)="textBoxChangeEvent($event)"
      data-cy="billAccountPaymentsDifferentPaymentAmount"
    />
  </ds-form-control-container>
</div>
